//eslint-disable eqeqeq
import React, { useCallback, useRef, useState } from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";
import classnames from "classnames";
import SweetAlert from "react-bootstrap-sweetalert";
import moment from "moment";
import {
  AsyncTableInfinite,
  Form,
  Intl,
  TextField,
  PaymentModal,
} from "components";
import { formatNumeral } from "utils";
import {
  composeValidators,
  greaterThanOrEqual,
  required,
} from "config/InputErrors";

const hiddenIsLoading = true;

export default ({
  data,
  accountData,
  isLoading,
  parentPath,
  onReload,
  onFetchData,
  onBuyCredit,
  onReloadAccount,
  onDownloadInvoice,
  userData,
}) => {
  const [paymentModal, setPaymentModal] = useState(false);
  const [warningModal, setWarningModal] = useState(false);
  const formDataRef = useRef(null);

  const togglePaymentModal = useCallback((formData) => {
    if (accountData && accountData.fiscalName!=null && accountData.fiscalName!="") {
      formDataRef.current = formData;
      setPaymentModal((state) => !state);
    } else {
      setWarningModal((state) => !state);
    }
  }, [accountData]);

  return (
    <Container
      fluid
      className={classnames({
        "app-component-loading": isLoading,
      })}
    >
      <Row>
        <Col className="text-sm">
          <Intl
            id="addCreditAmountTitle"
            values={{
              value: formatNumeral(20),
              currency: userData.currency_name,
            }}
          />
          :
        </Col>
      </Row>
      <Form
        showErrorsInHeader
        onSubmit={togglePaymentModal}
        body={(form) => {
          const formValues = form.getState().values || {};
          return (
            <Row className="mt-3">
              <Col lg={3} />
              <Col md={6} lg={3} className="m-auto">
                <Row className="mb-3">
                  <Col className="offset-md-2">
                    <TextField
                      type="number"
                      field="amount"
                      inputClassName="bg-mp-orange-7"
                      formGroupClass="m-0"
                      validate={composeValidators(
                        required,
                        greaterThanOrEqual(20)
                      )}
                      validateTranslateValues={{ label: formatNumeral(20) }}
                      onChange={(value) => {
                        if (value < 20) {
                          form.change("iva", null);
                          form.change("total", null);
                        } else {
                          const total = Number(value);
                          if (accountData && accountData.taxes==0 && accountData.vat!="") {
                            form.change("iva", formatNumeral(0));
                            form.change("total", formatNumeral(total));
                          } else if(accountData && accountData.taxes) {
                            const iva = total * 0.21;
                            form.change("iva", formatNumeral(iva));
                            form.change("total", formatNumeral(iva + total));
                          } 
                          else {
                            form.change("total", formatNumeral(total));
                          }
                        }
                      }}
                    />
                  </Col>
                  <Col md="auto" className="pl-md-0 mt-1 text-sm">
                    <Intl
                      id="currency"
                      values={{ currency: userData.currency_name }}
                    />
                  </Col>
                </Row>

                {/* {((accountData && accountData.taxes) || (accountData && accountData.taxes==0 && accountData.vat!="")) && ( */}
                {((accountData && accountData.taxes) || (accountData && accountData.vat=="")) && (
                  <Row className="mb-1">
                    <Col md={2} className="mt-1 text-md-right p-md-0 text-sm">
                      <Intl id="iva" />
                    </Col>
                    <Col md>
                      <div
                        className="bg-mp-gray-3 d-flex align-items-center px-2"
                        style={{ height: 33 }}
                      >
                        {formValues.iva || <span />}
                      </div>
                    </Col>
                    <Col md="auto" className="pl-md-0 mt-1 text-sm">
                      <Intl
                        id="currency"
                        values={{ currency: userData.currency_name }}
                      />
                    </Col>
                  </Row>
                )}

                <Row>
                  <Col md={2} className="mt-1 text-md-right p-md-0 text-sm">
                    <Intl id="total" />
                  </Col>
                  <Col md>
                    <div
                      className="bg-mp-gray-3 d-flex align-items-center px-2"
                      style={{ height: 33 }}
                    >
                      {formValues.total || <span />}
                    </div>
                  </Col>
                  <Col md="auto" className="pl-md-0 mt-1 text-sm">
                    <Intl
                      id="currency"
                      values={{ currency: userData.currency_name }}
                    />
                  </Col>
                </Row>
              </Col>
              <Col lg={3} className="text-lg-right mt-3 mt-lg-0">
                <p className="m-0 lh-100">
                  <Intl id="invoiceOrVatExempt" />
                </p>
                <Link to={`${parentPath}/billing`} className="text-mp-blue-1">
                  <Intl id="editFiscalData" />
                </Link>
              </Col>

              {paymentModal && (
                <PaymentModal
                  paymentData={formDataRef.current}
                  open={paymentModal}
                  onClose={togglePaymentModal}
                  onSubmit={onBuyCredit}
                  onSuccessPayment={() => {
                    onReload();
                    onReloadAccount();
                    togglePaymentModal();
                    form.initialize({});
                    form.resetFieldState("amount");
                  }}
                  userData={userData}
                />
              )}
              {warningModal && (
                <SweetAlert
                  title=""
                  onConfirm={() => {}}
                  custom
                  show={warningModal}
                  showCloseButton
                  customButtons={<></>}
                  onCancel={() => setWarningModal(false)}
                  style={{ width: "fit-content" }}
                >
                  <span style={{ color: "#000000", padding: "0 5rem" }}>
                    <Intl id="errorNoNumber1" />
                    <Link to={`${parentPath}/billing`}>
                      {" "}
                      <Intl id="fiscalData" />{" "}
                    </Link>
                    <Intl id="errorNoNumber2" />
                  </span>
                </SweetAlert>
              )}
            </Row>
          );
        }}
        footer={
          <Row className="mt-3 mb-5">
            <Col className="text-center">
              <Button
                color="app-default"
                size="app-sm"
                className="font-weight-700 mr-2"
              >
                <Intl id="payHere" />
              </Button>
            </Col>
          </Row>
        }
      />

      <Row className="mt-3">
        <Col>
          <AsyncTableInfinite
            data={data.data}
            isLoading={isLoading}
            hiddenIsLoading={hiddenIsLoading}
            total={data.total}
            onFetchData={onFetchData}
            defaultSortBy={[{ id: "createdAt", desc: true }]}
            titleContent={<Intl id="paymentHistory" />}
            values={{ currency: "(" + userData.currency_symbol + ")" }}
            tableName="paymentHistory"
            columns={[
              {
                Header: "dateAndTime",
                accessor: "createdAt",
                width: 25,
                // Cell: ({ cell }) =>
                //   cell.value
                //     ? moment(Number(cell.value)).format("YYYY-MM-DD HH:mm")
                //     : "",
                Cell: ({ cell }) =>
                  cell.value
                    ? cell.value
                    : "",
              },
              {
                Header: "invoiceNo",
                accessor: "invoiceNo",
                id:"numberInvoice",
                width: 25,
              },
              {
                Header: "amountCurrency",
                accessor: "amountWithoutIva",
                id: "amount",
                width: 25,
                Cell: ({ cell }) => formatNumeral(cell.value),
              },
              {
                Header: "invoice",
                accessor: "id",
                disableSorting: true,
                width: 25,
                Cell: ({ cell }) => (
                  <>
                    <Button
                      color="outline-link"
                      className="p-0 lh-110"
                      onClick={() => {
                        onDownloadInvoice(cell.value);
                      }}
                    >
                      <Intl id="download" />
                    </Button>
                  </>
                ),
              },
            ]}
            headerWidth={["col", "col", "col", "col"]}
          />
        </Col>
      </Row>
      <Col className="text-sm" >

      <Intl  id="footNodeOnAdministration" />
      </Col>
    </Container>
  );
};
